import { addPreservedParams } from "@mozioinc/utils";
import { useMutation } from "@tanstack/react-query";
import { useCheckoutStore } from "../stores";
import { authQuery } from "../utils/auth";
import { resetPostHogUser } from "../utils/posthog";
import { getRefreshToken, removeTokens } from "../utils/token";

export const useLogout = () => {
  const tokenBlacklistMutation = useMutation({
    mutationFn: authQuery.tokenBlacklist,
  });
  const { reset } = useCheckoutStore();

  const logout = async () => {
    const refreshToken = getRefreshToken();

    try {
      if (refreshToken) {
        const data = await tokenBlacklistMutation.mutateAsync({
          refreshToken,
        });

        if ("error" in data) {
          // Best-effort server-side invalidation — the token may already be
          // rotated/blacklisted by a concurrent refresh, which isn't actionable
          // here. Local cleanup below must still run regardless.
          console.error(data.message);
        }
      }
    } finally {
      // Any unexpected failure (e.g. network error) propagates past this
      // block to Sentry as normal — cleanup below still runs first.
      removeTokens();
      reset();
      resetPostHogUser();
      window.location.href = addPreservedParams("/");
    }
  };

  return logout;
};
